function fallback(to) {
  window.scrollTo(0, to);
}

export default function scroll(to = 0, smooth = true) {
  if (smooth) {
    try {
      window.scrollTo({
        behavior: 'smooth',
        left: 0,
        top: to,
      });
    } catch (err) {
      fallback(to);
    }
  } else {
    fallback(to);
  }
}
